module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am46-8c060d3fae66eb4449dcaa69a8314f4d.jpg";